import { render } from "./CookieConsent.vue?vue&type=template&id=2bf61be1"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=2bf61be1&lang=css"
script.render = render

export default script